import { Icon, IconButton, Tooltip } from "@material-ui/core";
import React from "react";
import PrimaryTheme from "../Themes/Primary";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRange } from "react-date-range";
import { useSelector } from "react-redux";
import "./filters.scss";
import { DebounceInput } from "react-debounce-input";
import Input from "./Input";
import Select from "react-select";
export default function UtilityFilters(props: FilterProps) {
  const onMouseEnter = () => {
    // setShow(!show);
    const el = document.querySelector(".date-range-holder");
    el?.classList.remove("d-none");
  };

  const onMouseOut = () => {
    const el = document.querySelector(".date-range-holder");
    el?.classList.add("d-none");
  };
  const option: any = [];
  const aggregatorOption: any = [];
  React.useEffect(() => {
    props?.listOfAgents?.map((list: any) => {
      option.push({
        value: list.id,
        label: list.name,
      });
    });
  }, [props.listOfAgents, option]);

  React.useEffect(() => {
    if (Array.isArray(props?.listOfAggregator)) {
      props.listOfAggregator.map((list: any) =>
        aggregatorOption.push({
          value: list.id,
          label: list.name,
        })
      );
    }
  }, [props.listOfAggregator, aggregatorOption]);

  return (
    <div>
      {props.hasSearch && (
        <div className="row m-0 justify-content-space">
          <div className="input-group bg-light">
            <div className="input-group-prepend bg-light">
              <span
                className="input-group-text bg-light border-0 border-radius-none text-bold text-dark"
                id="basic-addon1"
              >
                {" "}
                <Icon>search</Icon>{" "}
              </span>
            </div>
            <form
              autoComplete="off"
              style={{ width: "50%" }}
              className="search__filter"
            >
              <DebounceInput
                minLength={0}
                value={props.searchState}
                debounceTimeout={500}
                onChange={props.handleSearch}
                type="text"
                inputMode="text"
                autoComplete="off"
                placeholder="Search here..."
                className="form-control outline-0 bg-light border-0"
              />

              {/* <input type="text" inputMode="text" autoComplete="off" placeholder="Search here..." value={props.searchState} className="form-control outline-0 bg-light border-0" onChange={props.handleSearch} /> */}
            </form>

            <div className="input-group-append bg-light ml-auto">
              <span
                className="input-group-text  border-radius-none small text-white pointer"
                style={{
                  backgroundColor: PrimaryTheme.primary,
                  fontSize: PrimaryTheme.fontSizes?.body,
                }}
                id="basic-addon1"
                onClick={props.onClick}
              >
                Search
              </span>
              <Tooltip title="Reset">
                <IconButton onClick={props.onClear}>
                  <Icon fontSize="small">refresh</Icon>
                </IconButton>
              </Tooltip>
            </div>
          </div>
        </div>
      )}
      {props.hasTarget && (
        <div className="text-right pt-2" onMouseEnter={onMouseOut}>
          <div className="input-group bg-light w-100">
            <div className="input-group-prepend bg-light">
              <span
                className="input-group-text  border-0 border-radius-none text-bold text-white"
                id="basic-addon1"
                style={{
                  backgroundColor: PrimaryTheme.primary,
                }}
              >
                {" "}
                Status
              </span>
            </div>

            <select
              name="posTarget"
              id="posTarget"
              value={props.posTarget}
              onChange={props.posTargetChange}
              className="custom-select bg-light outline-0 border-0"
            >
              <option value={""}>Select</option>
              <option value={0}>Active</option>
              <option value={1}>Inactive</option>
              <option value={2}>Non Transacting</option>
            </select>
          </div>
        </div>
      )}

      {props.hasAgent && (
        <div className="text-right pt-2" onMouseEnter={onMouseOut}>
          <div className="input-group bg-light w-100">
            <div className="input-group-prepend bg-light">
              <span
                className="input-group-text  border-0 border-radius-none text-bold text-white"
                id="basic-addon1"
                style={{
                  backgroundColor: PrimaryTheme.primary,
                }}
              >
                {" "}
                Agent Name
              </span>
            </div>
            <div style={{ width: "66%" }}>
              <Select
                options={option}
                // onChange={props.agentStateChange}
                value={props.agentState}
                onChange={props.agentStateChange}
                inputValue={props.agentState}
                openMenuOnClick={props.agentStateChange}
                onInputChange={props.agentStateChange}
              />
            </div>
            {/* <select
              name="posTarget"
              id="posTarget"
              value={props.agentState}
              onChange={props.agentStateChange}
              className="custom-select bg-light outline-0 border-0"
            >
              <option value={""}>Select</option>
              {props.listOfAgents &&
                props.listOfAgents.map((list: any) => (
                  <option value={list.id}>{list.name}<  /option>
                ))}
            </select> */}
          </div>
        </div>
      )}
      {props.hasAggregator && (
        <div className="text-right pt-2" onMouseEnter={onMouseOut}>
          <div className="input-group bg-light w-100">
            <div className="input-group-prepend bg-light">
              <span
                className="input-group-text  border-0 border-radius-none text-bold text-white"
                id="basic-addon1"
                style={{
                  backgroundColor: PrimaryTheme.primary,
                }}
              >
                {" "}
                Aggregator Name
              </span>
            </div>

            {/* <select
              name="posTarget"
              id="posTarget"
              value={props.aggregatorState}
              onChange={props.aggregatorStateChange}
              className="custom-select bg-light outline-0 border-0"
            >
              <option value={""}>Select</option>
              {Object.keys(props.listOfAggregator).length !== 0 &&
                props.listOfAggregator.map((list: any) => (
                  <option value={list.id}>{list.name}</option>
                ))}
            </select> */}
            <div style={{ width: "65%" }}>
              <Select
                options={aggregatorOption}
                // onChange={props.agentStateChange}
                value={props.aggregatorState}
                onChange={props.aggregatorStateChange}
                inputValue={props.aggregatorState}
                openMenuOnClick={props.aggregatorStateChange}
                onInputChange={props.aggregatorStateChange}
              />
            </div>
          </div>
        </div>
      )}

      {props.hasGeneralStatus && (
        <div className="text-right pt-2" onMouseEnter={onMouseOut}>
          <div className="input-group bg-light w-100">
            <div className="input-group-prepend bg-light">
              <span
                className="input-group-text  border-0 border-radius-none text-bold text-white"
                id="basic-addon1"
                style={{
                  backgroundColor: PrimaryTheme.primary,
                }}
              >
                {" "}
                Status
              </span>
            </div>

            <select
              name="generalStatus"
              id="posTarget"
              value={props.status}
              onChange={props.statusChange}
              className="custom-select bg-light outline-0 border-0"
            >
              <option value={""}>Select</option>
              <option value={0}>Success</option>
              <option value={1}>Pending </option>
              <option value={2}>Failed</option>
            </select>
          </div>
        </div>
      )}

      {props.hasGeneralType && (
        <div className="text-right pt-2" onMouseEnter={onMouseOut}>
          <div className="input-group bg-light w-100">
            <div className="input-group-prepend bg-light">
              <span
                className="input-group-text  border-0 border-radius-none text-bold text-white"
                id="basic-addon1"
                style={{
                  backgroundColor: PrimaryTheme.primary,
                }}
              >
                {" "}
                Type
              </span>
            </div>

            <select
              name="generalStatus"
              id="posTarget"
              value={props.type}
              onChange={props.typeChange}
              className="custom-select bg-light outline-0 border-0"
            >
              <option value={""}>Select</option>
              {props.typeList &&
                props.typeList.map((list: any) => (
                  <option value={list.id}>{list.name}</option>
                ))}
            </select>
          </div>
        </div>
      )}
    </div>
  );
}

interface FilterProps {
  hasAgent?: boolean;
  agentState?: any;
  agentStateChange?: any;
  hasTarget?: boolean;
  posTargetChange?: any;
  posTarget?: any;
  hasSearch?: boolean;
  searchState?: any;
  onClick?: any;
  onClear?: any;
  handleSearch?: any;
  handleSelect?: any;
  listOfAgents?: any;
  aggregatorStateChange?: any;
  aggregatorState?: any;
  listOfAggregator?: any;
  hasAggregator?: boolean;
  hasGeneralStatus?: boolean;
  status?: any;
  statusChange?: any;
  hasGeneralType?: boolean;
  type?: any;
  typeChange?: any;
  typeList?: any;
}
